import React, { useState, useEffect, useRef } from 'react';

const API = process.env.REACT_APP_BACKEND_URL || '';

const SupplierProductSearch = ({ onOfferAdded }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [selected, setSelected] = useState(null);
  const [price, setPrice] = useState('');
  const [available, setAvailable] = useState(true);
  const [minQty, setMinQty] = useState('1');
  const [label, setLabel] = useState('');
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState(false);
  const [showDrop, setShowDrop] = useState(false);
  const timer = useRef(null);

  useEffect(() => {
    if (query.length < 2) { setResults([]); setShowDrop(false); return; }
    clearTimeout(timer.current);
    timer.current = setTimeout(async () => {
      try {
        const r = await fetch(API + '/api/products?q=' + encodeURIComponent(query) + '&limit=10&include_empty=true');
        const d = await r.json();
        setResults(Array.isArray(d) ? d : (d.products || []));
        setShowDrop(true);
      } catch(e) { setResults([]); }
    }, 350);
  }, [query]);

  const selectProduct = (p) => {
    setSelected(p);
    setQuery(p.name);
    setShowDrop(false);
    setLabel(p.variants && p.variants[0] ? p.variants[0].label : '');
  };

  const save = async () => {
    if (!selected || !price) return;
    setSaving(true);
    try {
      const token = localStorage.getItem('dz_token');
      const r = await fetch(API + '/api/supplier/products/' + selected.id + '/offer', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token },
        body: JSON.stringify({ label: label || 'Standard', price: parseFloat(price), in_stock: available, stock: available ? 999 : 0, min_qty: parseInt(minQty) || 1 }),
      });
      if (r.ok) {
        setSuccess(true);
        setSelected(null); setQuery(''); setPrice(''); setAvailable(true); setMinQty('1'); setLabel('');
        if (onOfferAdded) onOfferAdded();
        setTimeout(() => setSuccess(false), 3000);
      }
    } catch(e) {}
    setSaving(false);
  };

  return (
    <div className="bg-white rounded-2xl border border-[#E8E0D0] p-6">
      <h3 className="text-lg font-semibold text-[#1F4D3F] mb-2">
        Ajouter mon offre sur un produit existant
      </h3>
      <p className="text-sm text-[#7A6F5C] mb-4">
        Cherchez un produit du catalogue et ajoutez votre prix.
      </p>

      {success && (
        <div className="mb-4 p-3 bg-[#E4EDE9] rounded-xl text-[#1F4D3F] text-sm font-medium">
          Offre ajoutee avec succes !
        </div>
      )}

      <div className="relative mb-4">
        <input
          value={query}
          onChange={function(e) { setQuery(e.target.value); setSelected(null); }}
          placeholder="Chercher un produit (ex: Septanest, Tetric, NSK...)"
          className="w-full px-4 py-3 border border-[#E8E0D0] rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-[#1F4D3F] bg-[#FAFAF8]"
        />
        {showDrop && results.length > 0 && (
          <div className="absolute top-full left-0 right-0 z-50 bg-white border border-[#E8E0D0] rounded-xl shadow-xl mt-1 max-h-64 overflow-y-auto">
            {results.map(function(p) {
              return (
                <button key={p.id} onClick={function() { selectProduct(p); }}
                  className="w-full flex items-center gap-3 px-4 py-3 hover:bg-[#F5F1EA] text-left border-b border-[#F0EBE3] last:border-0">
                  <div className="flex-1 min-w-0">
                    <div className="text-sm font-medium text-[#2D2A26] truncate">{p.name}</div>
                    <div className="text-xs text-[#C75B27]">{p.brand}</div>
                    <div className="text-xs text-[#9A8F82]">{p.variants ? p.variants.length : 0} offre(s) existante(s)</div>
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </div>

      {selected && (
        <div className="border border-[#E4EDE9] rounded-xl p-4 bg-[#F5F9F7]">
          <div className="font-semibold text-[#1F4D3F] text-sm mb-3">{selected.name} — {selected.brand}</div>
          <div className="grid grid-cols-1 gap-3">
            <div>
              <label className="text-xs font-medium text-[#5A5247] block mb-1">Conditionnement *</label>
              <input value={label} onChange={function(e) { setLabel(e.target.value); }}
                placeholder="ex: Boite 50 carpules, Seringue 4g A2..."
                className="w-full px-3 py-2.5 border border-[#E8E0D0] rounded-lg text-sm focus:outline-none bg-white" />
            </div>
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="text-xs font-medium text-[#5A5247] block mb-1">Prix (DA) *</label>
                <input value={price} onChange={function(e) { setPrice(e.target.value); }}
                  type="number" placeholder="3800"
                  className="w-full px-3 py-2.5 border border-[#E8E0D0] rounded-lg text-sm focus:outline-none bg-white" />
              </div>
              <div>
                <label className="text-xs font-medium text-[#5A5247] block mb-1">Quantité min.</label>
                <input value={minQty} onChange={function(e) { setMinQty(e.target.value); }}
                  type="number" min="1" placeholder="1"
                  className="w-full px-3 py-2.5 border border-[#E8E0D0] rounded-lg text-sm focus:outline-none bg-white" />
                <p className="text-[10px] text-[#9A8F82] mt-1">Ex: 10 = prix valable à partir de 10 unités</p>
              </div>
              <div>
                <label className="text-xs font-medium text-[#5A5247] block mb-1">Disponibilité</label>
                <div className="flex gap-2">
                  <button type="button" onClick={function() { setAvailable(true); }}
                    className={"flex-1 px-3 py-2.5 rounded-lg text-sm font-medium border transition-colors " + (available ? "bg-[#1F4D3F] text-white border-[#1F4D3F]" : "bg-white text-[#5A5247] border-[#E8E0D0]")}>
                    Disponible
                  </button>
                  <button type="button" onClick={function() { setAvailable(false); }}
                    className={"flex-1 px-3 py-2.5 rounded-lg text-sm font-medium border transition-colors " + (!available ? "bg-[#C75B27] text-white border-[#C75B27]" : "bg-white text-[#5A5247] border-[#E8E0D0]")}>
                    Indisponible
                  </button>
                </div>
              </div>
            </div>
          </div>
          <button onClick={save} disabled={!price || saving}
            className="mt-4 w-full bg-[#1F4D3F] hover:bg-[#173B30] text-white py-2.5 rounded-xl text-sm font-semibold transition-colors disabled:opacity-50">
            {saving ? 'Enregistrement...' : 'Ajouter mon offre'}
          </button>
        </div>
      )}
    </div>
  );
};

export default SupplierProductSearch;
